const styles = {
  container: {
    width: "100%",
    height: "100%",
    flex: 1,
    "line-height": 0,
    "max-width": "100%",
    overflow: "hidden",
    position: "relative",
  },
  "@keyframes fadein": {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
  tooltip: {
    position: "absolute",
    top: 0,
    left: 0,
    "user-select": "none",
    display: "block",
    visibility: "hidden",
    "z-index": 1000,
    padding: "4px 17px",
    "font-size": "1rem",
    "line-height": "1rem",
    "border-radius": "5px",
    "background-color": "rgba(0, 0, 0, 0.5)",
    color: "white",
    "&.visible": {
      visibility: "visible",
    },
  },
  clear: {
    clear: "both",
  },
};

export default styles;
